// called "Unstable" b/c considered a breaking change, but supported going forward in MUI - more details here - https://mui.com/material-ui/react-grid2/#whats-changed
import { ElementType, ForwardRefExoticComponent, forwardRef } from 'react'
import { OverrideProps } from '../../types/mui.types'
import MuiGrid, { Grid2Props } from '@mui/material/Unstable_Grid2'

type GridBaseProps = Pick<
  Grid2Props,
  | 'children'
  | 'columnGap'
  | 'columns'
  | 'columnSpacing'
  | 'container'
  | 'direction'
  | 'disableEqualOverflow'
  | 'gap'
  | 'id'
  | 'key'
  | 'lg'
  | 'lgOffset'
  | 'md'
  | 'mdOffset'
  | 'rowGap'
  | 'rowSpacing'
  | 'sm'
  | 'smOffset'
  | 'spacing'
  | 'sx'
  | 'xl'
  | 'xlOffset'
  | 'xs'
  | 'xsOffset'
>

interface Grid2TypeMap<P = Record<string, never>, D extends ElementType = 'div'> {
  props: Omit<P, 'style'> & GridBaseProps
  defaultComponent: D
}

export type GridProps<
  D extends ElementType = Grid2TypeMap['defaultComponent'],
  P = { component?: ElementType }
> = OverrideProps<Grid2TypeMap<P, D>, D>

/**
 * The Grid component works well for a layout with a known number of columns.
 * The columns can be configured with multiple breakpoints to specify the column span of each child.
 *
 * Documentation: https://mui.com/material-ui/react-grid2
 */
export const Grid: ForwardRefExoticComponent<GridProps> = forwardRef((props, ref) => {
  return <MuiGrid ref={ref} {...props} />
})
Grid.displayName = 'Grid'
